function moneyToCapital(n) {
    if (n === 0) {
        return "零";
    }
    let str = "";
    if (n < 0) {
        n = -n;
        //str += "负";
    }
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
        return "";
    var unit = "千百拾亿千百拾万千百拾元角分";
    n += "00";
    var p = n.indexOf('.');
    if (p >= 0)
        n = n.substring(0, p) + n.substr(p + 1, 2);
    unit = unit.substr(unit.length - n.length);
    for (var i = 0; i < n.length; i++)
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    return str.replace(/零(千|百|拾|角)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(万|亿|元)/g, "$1")
        .replace(/(亿)万|壹(拾)/g, "$1$2")
        .replace(/^元零?|零分/g, "")
        .replace(/元$/g, "元整");
}

/**
 * 对数字进行处理，保留 decimal 位小数位
 */
function fixedNumber(value, decimal) {
    value = parseFloat(value);
    //处理toFixed默认的银行家舍入法
    let val = value.toFixed(decimal);
    let diff = 0.5;
    let t = 1;
    for(let i = 0; i< decimal; i++) {
        diff = diff / 10;
        t = t / 10;
    }
    if(value >= (parseFloat(val) + parseFloat(diff)) ){
        value = parseFloat(val) + parseFloat(t);
    }else{
        value = val;
    }
    value = parseFloat(value);
    value = value.toFixed(decimal);
    return parseFloat(value);
}

function toDecimal2(x) {
    let f = parseFloat(x);
    if (isNaN(f)) {
        return 0.00;
    }
    let s = f.toFixed(2) + "";
    let rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    return s;
}

function moneyFormat(value) {
    if (value == null || value === "") {
        return '';
    }
    return "￥" + toDecimal2(value);
}

/**
 * 对一个string格式的数字加一，返回跟原数字一样长度的字符串数字
 */
function stringAddOne(value) {
    if (value == null || value === "") {
        return "1"; //如果为空则返回1
    } else {
        let length = value.length;
        value = parseInt(value);
        value++;
        value = value + "";
        if (value.length < length) {
            for (let i = value.length; i < length; i++) {
                value = "0" + value;
            }
        }
        return value;
    }
}

let dateUtil = {
    getCurrentMonthLastDay: '',
    getCurrentMonthFirstDay: ''
};

dateUtil.getCurrentMonthLastDay = () => {
    let nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth() + 1;
    let day = new Date(year, month, 0).getDate();
    let yyyyMMdd = "" + year + (month < 10 ? ('0' + month) : month) + (day < 10 ? ('0' + day) : day);
    return yyyyMMdd;
}

dateUtil.getCurrentMonthFirstDay = () => {
    let nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth() + 1;
    let yyyyMMdd = "" + year + (month < 10 ? ('0' + month) : month) + '01';
    return yyyyMMdd;
}

/**
 * 将文件转成base64
 * @param {*} file  要处理的文件
 */
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

/**
 * Rate贷款年利率。
 * Nper该项贷款的付款总期数(总年数或还租期数）。
 * Pv现值（租赁本金），或一系列未来付款的当前值的累积和，也称为本金。
 * 每月还款额 = 总贷款额 X 月利率 X ( 1+月利率 ) ^ 还款期数 / ( ( 1+月利率 ) ^ 还款期数 -1 )
 */
function pmt(rate, nPer, pv) {
    let repay = pv * (rate / 12) * Math.pow((1 + rate / 12), nPer) / (Math.pow((1 + rate / 12), nPer) - 1);
    return repay;
}

/**
 * 拷贝对象，深度拷贝避免因为引用引起问题
 * @param {*} source 要拷贝的对象
 * @param {*} target 结果对象
 */
function copyObject(source, target) {
    target = target != null ? target : source.constructor === Array ? [] : {}; //最初的时候给它一个初始值=它自己或者是一个json
    for (var key in source) {
        if (typeof source[key] === "object") { //先判断一下 source[key]是不是一个对象
            target[key] = (source[key].constructor === Array) ? [] : {}; //我们让要复制的对象的name项=数组或者是json
            copyObject(source[key], target[key]); //然后来无限调用函数自己 递归思想
        } else {
            target[key] = source[key]; //如果不是对象，直接等于即可，不会发生引用。
        }
    }
    return target; //然后在把复制好的对象给return出去
}

/**
 * 校验一个证件号码是不是身份证
 * @param {*} creditNo
 */
function checkIdNo(creditNo) {
    if (creditNo === undefined || creditNo == null) return false;
    let idRegex = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    return idRegex.test(creditNo);
}

// 验证请求路径，不包含http协议、服务地址和端口
function checkUnneedLoginPath() {
    let pathname = window.location.pathname;
    var pathRegex = /(^\/visitor\/)|(^\/wx\/)/;
    return pathRegex.test(pathname);
}
   /**
     * 数字格式化
     */
function  numFormat(num){
    let result = '';
    let counter = 0;
    num = (num || 0).toString();
    for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i !== 0) {
            result = ',' + result;
        }
    }
    return result;
}

/**
 * 格式化时间，格式化完成后的格式为 YYYY-MM-dd HH:mm:ss
 */
function formatDateTime(date) {
    if(date == null ) return "";
    if (typeof date === 'number' && !isNaN(date)) {
        date = new Date(date);
    } else if (date instanceof Date) {

    } else {
        return date;
    }
    var YY = date.getFullYear();
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return YY + '-' + MM + '-' + DD + " " + hh + ':' + mm + ':' + ss;
}

/**
 * 格式化时间，格式化完成后的格式为 YYYY-MM-dd
 */
function formatDate(date) {
    if(date == null ) return "";
    if (typeof date === 'number' && !isNaN(date)) {
        date = new Date(date);
    } else if (date instanceof Date) {

    } else {
        return date;
    }
    var YY = date.getFullYear();
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    return YY + '-' + MM + '-' + DD;
}

/** 获取页面路径中的参数 */
function getUrlParam(paramName){
    var url = window.location.href;
    var oRegex = new RegExp("[?&]" + paramName + "=([^&]+)", "i");
    var oMatch = oRegex.exec(url);
    if (oMatch && oMatch.length > 1) {
        return decodeURI(oMatch[1]);
    } else {
        return "";
    }
}

function generateSixDigits() {
    return Array.from({length: 6}, () => Math.floor(Math.random() * 10)).join('');
}

export { moneyToCapital, fixedNumber, dateUtil, moneyFormat, stringAddOne, getBase64, pmt, copyObject, checkIdNo, checkUnneedLoginPath, formatDateTime, formatDate ,numFormat, getUrlParam, generateSixDigits};
